import './index.less'
import { footerPhoneSubs, shopCR } from "@utils/api.js"

class PhotovolaticSaveElectric {
  constructor({ el }) {
    this.DOM = document.querySelector(el);
    this.animated = false; // 动画状态锁
    
    if (this.DOM) {
      this.init();
      // 使用 rAF 确保 DOM 稳定后再执行观察
      requestAnimationFrame(() => this.observe());
    }
  }

  init() {
    this.initSaveElecticRate();
    this.initFundingGrant();

    try {
      const subBtn = document.querySelector('[data-photovolatic-subscribe]');
      if (subBtn) this.initEmailSubscribe();
    } catch (error) {
      console.error('Init Error:', error);
    }
  }

  // 比率计算
  initSaveElecticRate() {
    const withStorage = document.querySelector('[data-with-storage]');
    const withoutStorage = document.querySelector('[data-without-storage]');
    
    if (withStorage && withoutStorage && this.DOM) {
      const withNumber = parseInt(withStorage.dataset.number) || 1;
      const withoutNumber = parseInt(withoutStorage.dataset.number) || 0;
      const rate = (withoutNumber / withNumber) * 100 + '%';
      this.DOM.style.setProperty('--photovolatic-storage-rate', rate);
    }
  }

  // 邮箱订阅逻辑 (保持原逻辑并增加空校验)
  initEmailSubscribe() {
    const subBtn = document.querySelector('[data-photovolatic-subscribe]');
    if (!subBtn) return;

    subBtn.onclick = (e) => {
      const emailInput = document.querySelector('[data-photovolatic-email-input]');
      if (!emailInput) return;

      // Checkbox 校验
      const $checkbox = $('.J-subscribe-declaration-checkbox');
      if ($checkbox.length > 0 && !$checkbox[0].checked) {
        $('.J-subscribe-declaration-span').addClass('wobble-hor-bottom');
        setTimeout(() => $('.J-subscribe-declaration-span').removeClass('wobble-hor-bottom'), 1100);
        return;
      }

      const email = emailInput.value.trim();
      if (!email) {
        pushMessage(shopCR === 'DE' ? 'Geben sie ihre E-Mailadresse ein' : 'Enter Your Email Address', 'warning');
        return false;
      }

      const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailReg.test(email)) {
        pushMessage(shopCR === 'DE' ? 'Ungültige E-Mail-Adresse' : 'Invalid Email Address', 'warning');
        return false;
      }

      footerPhoneSubs({ email, tags: "DIY SG" }).then((res) => {
        if (res.code === 200) {
          pushSuccessMessage(shopCR === 'DE' ? 'Erfolgreich!' : "Success!");
          emailInput.value = '';
        } else {
          pushErrorMessage(res.code === 70002 ? 'Invalid Phone Number' : 'Server Error');
        }
      });

      // GA 埋点
      const { sectionTitle, buttonText } = e.target.dataset;
      this.GAEvent({ position: sectionTitle, button_name: buttonText });
    };

    // 协议文本替换
    const $span = $('.J-subscribe-declaration-span');
    if ($span.length > 0) {
      let html = $span.html();
      const map = {
        '{termsService}': `<a href="${$span.data('terms_service_url')}" target="_blank" class="underline">${$span.data('terms_service')}</a>`,
        '{PrivacyPolicy}': `<a href="${$span.data('privacy_policy_url')}" target="_blank" class="underline">${$span.data('privacy_policy')}</a>`
      };
      Object.keys(map).forEach(key => html = html.replace(key, map[key]));
      $span.html(html);
    }
  }

  initFundingGrant() {
    const grantBtn = document.querySelector('[data-photovolatic-funding-grant]');
    if (grantBtn) {
      grantBtn.onclick = e => {
        const { sectionTitle, buttonText } = e.target.dataset;
        this.GAEvent({ position: sectionTitle, button_name: buttonText });
      };
    }
  }

  // --- 核心优化：观察者逻辑 ---
  observe() {
    let scrollTimeout;
    const scrollHandler = () => {
      if (this.animated) return;
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(() => {
          const rect = this.DOM.getBoundingClientRect();
          // 如果组件已经出现在视口底部以上 100px
          if (rect.top < window.innerHeight + 100 && rect.bottom > -100) {
            runAnimation();
          }
          scrollTimeout = null;
        }, 150);
      }
    };

    const runAnimation = () => {
      if (this.animated) return;
      this.animated = true;
      this.triggerAnimation();
      // 触发后清理监听
      window.removeEventListener('scroll', scrollHandler);
    };

    // 1. Shopify 编辑模式直接显示
    if (window.Shopify && window.Shopify.designMode) {
      return runAnimation();
    }

    // 2. IntersectionObserver (增加 rootMargin 提前量)
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          runAnimation();
          observer.disconnect();
        }
      }, { 
        threshold: 0.01, 
        rootMargin: '50px 0px' // 提前 50px 触发，消除滑动时的白屏感
      });
      observer.observe(this.DOM);
    }

    // 3. iOS 滚动补丁：兜底高速滑动
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  // 执行动画逻辑
  triggerAnimation() {
    const progressBars = this.DOM.querySelectorAll('.balcony-progress');
    const labels = this.DOM.querySelectorAll('[data-label-fade-in]');
    
    progressBars.forEach((item, index) => {
      item.classList.add(`fill-${index + 1}`);
    });

    labels.forEach(item => {
      item.classList.remove('opacity-0');
      item.classList.add('label-fade-in');
      // 技巧：读取 offsetHeight 会强制浏览器同步刷新渲染树
      // 解决 iOS 异步添加类名不及时渲染的问题
      const _ = item.offsetHeight;
    });
  }

  GAEvent(params) {
    if (!window.dataLayer) return;
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"photovoltaics_user_clicks",
      "event_parameters":{
        "current_page": window.location.href,
        "module": "Collect Information",
        ...params
      }
    });
  }
}

// 统一初始化入口
const initComponent = () => {
  const wrapper = '.photovolatic-save-electricity-wrap';
  if (document.querySelector(wrapper)) {
    new PhotovolaticSaveElectric({ el: wrapper });
  }
};

document.addEventListener('DOMContentLoaded', initComponent);
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('section-photovolatic-save-electricity')) {
    initComponent();
  }
});